import { render } from "./ModalProductsAdd.vue?vue&type=template&id=2dc1795a"
import script from "./ModalProductsAdd.vue?vue&type=script&lang=js"
export * from "./ModalProductsAdd.vue?vue&type=script&lang=js"

import "./ModalProductsAdd.vue?vue&type=style&index=0&id=2dc1795a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__